<mat-card role="article">
    <mat-card-header role="heading">
        <mat-card-title>{{ data().titel }}</mat-card-title>
        @if (data().datum) {
            <mat-card-subtitle>{{ data().datum | date }}</mat-card-subtitle>
        }
    </mat-card-header>
    <img src="{{ data().image }}" [class.roundImage]="roundImage()" aria-hidden="true" />
    <mat-card-content>
        <!-- <span>{{data.titel}}</span> -->
        <p [innerHTML]="text() | nl2br | linky"></p>
    </mat-card-content>
    <mat-card-actions style="text-align: center">
        @if (data().mehr && data().mehr !== '') {
            <button mat-button routerLink="{{ data().mehr }}" aria-label="mehr Informationen anzeigen">mehr</button>
        }
    </mat-card-actions>
</mat-card>
